export const ToolsType = {
  DISPLAY: "display",
  ALIGN: "align",
};

export const ToolShape = {
  CIRCLE: "circle",
  SQUARE: "square",
};

export const POPUP_TYPES = {
  DISTANCE: "Distance",
  ANGLE: "Angle",
  ADVANCED_MEASUREMENTS: "Advanced Measurements",
};

export const TOOLS_TEXT = {
  LINEAR_MEASURE: "Linear Measures",
  ANGLE_MEASURE: "Angle Measures",
  ADVANCED_MEASURE: "Advanced Measures",
  DATA_FUSION: "Data Fusion",
  RADIODENSITY: "Radiodensity",
  THREE_D: "3D",
  SPINO_PELVIC_PARAMETERS: "Spino-pelvic Parameters",
  PLANNING_METHOD: "Planning Method",
  OSTEOTOMY: "Osteotomy",
  SPONDYLISTESIS_ADJUST: "Spondylolisthesis Adjust",
  CAGES: "Cages",
  SPINE_FUSION: "Spine Fusion",
  REVIEW_ACTIONS: "Review Actions",
  ADD_VERTEBRA: "Add A Vertebra",
  REMOVE_VERTEBRA: "Remove A Vertebra",
  ADD_LANDMARK: "Add A Landmark",
  REMOVE_LANDMARK: "Remove A Landmark",
};

export const POPUP_CONTENT_TYPES = {
  OSTEOTOMY: "Osteotomy",
  EDIT_OSTEOTOMY: "Edit Osteotomy",
  SEGMENTAL_TRANSFORMATION: "Spondylolisthesis adjust",
  CAGES: "Cages",
  FUSION: "Spine Fusion",
  GLOBAL_ALIGNMENT: "Global Alignment",
  EDIT_GLOBAL_Alignment: "Edit Global Alignment",
  ADD_VERTEBRA: "Add Vertebra",
  REMOVE_VERTEBRA: "Remove Vertebra",
  ADD_LANDMARK: "Add Landmark",
  REMOVE_LANDMARK: "Remove Landmark",
};

export const ToolCategory = {
  ADVANCED_MEASUREMENTS: "advancedMeasurements",
  DISTANCE: "distance",
  ANGLE: "angle",
};

export const InteractiveTools = {
  NONE: "none",
  DISTANCE_GENERIC: "distanceGeneric",
  DISTANCE_HORIZONTAL: "distanceHorizontal",
  DISTANCE_VERTICAL: "distanceVertical",
  ANGLE_HORIZONTAL: "angleHorizontal",
  ANGLE_VERTICAL: "angleVertical",
  ANGLE_INNER: "angleInner",
  ANGLE_4_POINTS: "angle4Points",
  ANGLE_COMP: "angleComp",
  ANGLE_COBB: "angleCobb",
  ANGLE_KYPHOSIS: "angleKyphosis",
  ANGLE_LORDOSIS: "angleLordosis",
  OSTEOTOMY: "osteotomy",
  SEGMENTAL_TRANSFORMATION: "segmentalTransformation",
  CAGES: "cages",

  RODS: "rods",
  BODY_LAYERS: "bodyLayers",
};

export const MeasurementType = {
  FOUR_POINTS_ANGLE: "SpineMeasure4PointsAngle",
  TWO_POINTS_ANGLE_HORIZONTAL: "SpineMeasure2PointsAngleWRTHorizontal",
  TWO_POINTS_ANGLE_VERTICAL: "SpineMeasure2PointsAngleWRTVertical",
  TWO_POINTS_CUSTOM_ANGLE_HORIZONTAL:
    "SpineMeasureCustom2PointsAngleWRTHorizontal",
  TWO_POINTS_CUSTOM_ANGLEL_VERTICAL:
    "SpineMeasureCustom2PointsAngleWRTVertical",
  FOUR_POINTS_ANGLE_PERPENDICULAR: "SpineMeasure4PointsAngleWRTPerpendicular",
  FOUR_POINTS_ANGLE_VERTICAL: "SpineMeasure4PointsAngleWRTVertical",
  FOUR_POINTS_ANGLE_INTERSECTION_ANTERIOR:
    "SpineMeasure4PointsAngleWithIntersectionAnterior",
  FOUR_POINTS_ANGLE_INTERSECTION_HORIZONTAL:
    "SpineMeasure4PointsAngleWithIntersectionHorizontal",
  FOUR_POINTS_ANGLE_INTERSECTION_POSTERIOR:
    "SpineMeasure4PointsAngleWithIntersectionPosterior",
  FOUR_POINTS_CUSTOM_ANGLE: "SpineMeasureCustom4PointsAngle",
  THREE_POINTS_ANGLE: "SpineMeasure3PointsAngle",
  THREE_POINTS_ANGLE_HORIZONTAL: "SpineMeasure3PointsAngleWRTHorizontal",
  THREE_POINTS_ANGLE_COMPLEMENTARY: "SpineMeasure3PointsComplementaryAngle",
  THREE_POINTS_ANGLE_SUPPLEMENTARY: "SpineMeasure3PointsSupplementaryAngle",
  THREE_POINTS_CUSTOM_ANGLE: "SpineMeasureCustom3PointsAngle",
  THREE_POINTS_CUSTOM_ANGLE_COMPLEMENTARY:
    "SpineMeasureCustom3PointsComplementaryAngle",
  DISTANCE: "SpineMeasureDistance",
  HORIZONTAL_DISTANCE: "SpineMeasureHorizontalDistance",
  VERTICAL_DISTANCE: "SpineMeasureVerticalDistance",
  GENERIC_CUSTOM_POINTS_DISTANCE: "SpineMeasureCustomPointsDistance",
  VERTICAL_CUSTOM_POINTS_DISTANCE: "SpineMeasureCustomVerticalDistance",
  HORIZONTAL_CUSTOM_POINTS_DISTANCE: "SpineMeasureCustomHorizontalDistance",

  // Helper method to get all values
  values() {
    return Object.values(this);
  },

  // Helper method to check if a value is valid
  isValid(value) {
    return this.values().includes(value);
  },
};

export const TOOL_TO_PYTHON_CLASS_MAP = {
  [InteractiveTools.DISTANCE_GENERIC]:
    MeasurementType.GENERIC_CUSTOM_POINTS_DISTANCE,
  [InteractiveTools.DISTANCE_HORIZONTAL]:
    MeasurementType.HORIZONTAL_CUSTOM_POINTS_DISTANCE,
  [InteractiveTools.DISTANCE_VERTICAL]:
    MeasurementType.VERTICAL_CUSTOM_POINTS_DISTANCE,
  [InteractiveTools.ANGLE_HORIZONTAL]:
    MeasurementType.TWO_POINTS_CUSTOM_ANGLE_HORIZONTAL,
  [InteractiveTools.ANGLE_VERTICAL]:
    MeasurementType.TWO_POINTS_CUSTOM_ANGLEL_VERTICAL,
  [InteractiveTools.ANGLE_INNER]: MeasurementType.THREE_POINTS_CUSTOM_ANGLE,
  [InteractiveTools.ANGLE_4_POINTS]: MeasurementType.FOUR_POINTS_CUSTOM_ANGLE,
  [InteractiveTools.ANGLE_COMP]:
    MeasurementType.THREE_POINTS_CUSTOM_ANGLE_COMPLEMENTARY,
  [InteractiveTools.ANGLE_COBB]: MeasurementType.FOUR_POINTS_ANGLE,
  [InteractiveTools.ANGLE_KYPHOSIS]: MeasurementType.FOUR_POINTS_ANGLE,
  [InteractiveTools.ANGLE_LORDOSIS]: MeasurementType.FOUR_POINTS_ANGLE,
};

export const TOOL_TO_CATEGORY_MAP = {
  // Distance tools
  [InteractiveTools.DISTANCE_GENERIC]: ToolCategory.DISTANCE,
  [InteractiveTools.DISTANCE_HORIZONTAL]: ToolCategory.DISTANCE,
  [InteractiveTools.DISTANCE_VERTICAL]: ToolCategory.DISTANCE,

  // Simple angle tools
  [InteractiveTools.ANGLE_HORIZONTAL]: ToolCategory.ANGLE,
  [InteractiveTools.ANGLE_VERTICAL]: ToolCategory.ANGLE,
  [InteractiveTools.ANGLE_INNER]: ToolCategory.ANGLE,
  [InteractiveTools.ANGLE_4_POINTS]: ToolCategory.ANGLE,
  [InteractiveTools.ANGLE_COMP]: ToolCategory.ANGLE,

  // Advanced measurement tools
  [InteractiveTools.ANGLE_COBB]: ToolCategory.ADVANCED_MEASUREMENTS,
  [InteractiveTools.ANGLE_KYPHOSIS]: ToolCategory.ADVANCED_MEASUREMENTS,
  [InteractiveTools.ANGLE_LORDOSIS]: ToolCategory.ADVANCED_MEASUREMENTS,
};
